import styles from "./Toggle.module.css"
import { cl } from "@nosto/search-js/utils"

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  className?: string
}

/**
 * An on/off switch with a visible ON/OFF state, used for the sidebar's
 * special filters (e.g. "Hide Out of Stock").
 */
export default function Toggle({ checked, onChange, label, className }: Props) {
  return (
    <label className={cl(styles.toggle, className)}>
      <input
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={e => onChange((e.target as HTMLInputElement).checked)}
      />
      <span className={styles.track}>
        <span className={styles.thumb} />
        <span className={styles.state}>{checked ? "ON" : "OFF"}</span>
      </span>
      <span className={styles.label}>{label}</span>
    </label>
  )
}
